import PropTypes from 'prop-types'
import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import {
  FormGroup,
  ControlLabel,
  ButtonGroup,
  HelpBlock,
} from 'react-bootstrap'
import Button from 'components/Button'
import Toggle from 'components/Toggle'
import CardTemplateField from 'components/CardTemplateField'
import { injectIntl } from 'react-intl'

export class EditAddressForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    onCancelClick: PropTypes.func.isRequired,
    boardId: PropTypes.number,
  }

  renderCardTemplateField = (field) => {
    return (
      <FormGroup
        validationState={field.meta.touched && field.meta.error ? 'error' : null}
      >
        <CardTemplateField
          boardId={this.props.boardId}
          value={field.input.value}
          onChange={field.input.onChange}
          emptyTitle={this.props.intl.formatMessage({ id: 'INCOMING_EMAILS_CARD_TEMPLATE_NULL' })}
        />
        {field.meta.touched && field.meta.error && <HelpBlock>{field.meta.error}</HelpBlock>}
      </FormGroup>
    )
  }

  renderValidateAddressField = (field) => {
    return (
      <FormGroup>
        <ControlLabel><FormattedMessage id='INCOMING_EMAILS_VALIDATE_ADDRESS_OPTION' /></ControlLabel>
        <div>
          <Toggle
            checked={field.input.value}
            onChange={field.input.onChange}
          />
        </div>
      </FormGroup>
    )
  }

  render () {
    const {
      handleSubmit,
      submitting,
      onCancelClick,
      boardId,
      error,
    } = this.props

    return (
      <form onSubmit={handleSubmit}>
        {boardId &&
          <Field
            name='cardTemplateId'
            component={this.renderCardTemplateField}
          />
        }
        <Field
          name='validateAddress'
          component={this.renderValidateAddressField}
        />
        <ButtonGroup>
          <Button type='submit' bsStyle='primary' disabled={submitting}><FormattedMessage id='SAVE' /></Button>
          <Button onClick={onCancelClick}><FormattedMessage id='CANCEL' /></Button>
        </ButtonGroup>
        {error &&
          <FormGroup
            validationState='error'
          >
            <HelpBlock>{error}</HelpBlock>
          </FormGroup>
        }
      </form>
    )
  }
}

export default injectIntl(reduxForm({
  form: 'editAddress'
})(EditAddressForm))
